var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLivestream = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2C0.895431 2 0 2.89543 0 4V12C0 13.1046 0.895431 14 2 14H9C10.1046 14 11 13.1046 11 12V4C11 2.89543 10.1046 2 9 2H2ZM5.5 5C3.27273 5 2 8 2 8C2 8 3.27273 11 5.5 11C7.72727 11 9 8 9 8C9 8 7.72727 5 5.5 5Z",
    fill: "#005E7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.5C6.32843 9.5 7 8.82843 7 8C7 7.17157 6.32843 6.5 5.5 6.5C4.67157 6.5 4 7.17157 4 8C4 8.82843 4.67157 9.5 5.5 9.5Z",
    fill: "#005E7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.27273L14.3668 3.33629C15.0197 2.80207 16 3.26662 16 4.11024V11.8898C16 12.7334 15.0197 13.1979 14.3668 12.6637L12 10.7273V5.27273Z",
    fill: "#005E7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLivestream);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/livestream.d8134e9c6f4f20bbc4f1b330eb5f5240.svg";